import { isEqual } from "lodash";
import { Dispatch, FC, Fragment, useMemo } from "react";
import { useSelector } from "../../../../../../store/store";
import InformationList, { LeftRightContent } from "../../../../components/InformationList";
import { ApprovalHistory } from "../../../../components/Progress/molecule/ApprovalHistory";
import TableModal from "../../../../components/detail";
import CommentSection from "../../../../info-technology-process/commentsection/comment-sections";
import { useProcess } from "../../../../process-context";
import { FileAttachmentCard } from "../../../../upload";
import { tableColumns } from "./table-column";
import { approverType } from "../../../../info-technology-process/code-process/codeRequestType";
import { UserSelect } from "../../../../../../components/input/select/UserSelect";
import { eApprovalChangeOptions } from "../../../companyRequestContants/companyRequestContants";
import { ExtraStateContext } from "..";

interface Props {
  setPickedItHead: Dispatch<any>
}

const FormContent: FC<Props> = (props) => {
  const { Request, approvalStep, approvalType, comment, setComment, pickedItHead, onApproverChange } = useProcess<ExtraStateContext>();
  const {setPickedItHead} = props
  const { fields } = Request;

  /**
   * Selector
   */
  const user = useSelector((state) => state.user);

  const {
    eDeptHeadComment,
    eITLeadComment,
    eITHeadComment,
    eAssigneeComment,
    eApprovedBy,
    eApprovedByITLead,
    eApprovedByITHead,
    eAssignee,
  } = fields;

  const smColData = useMemo(() => {
    return [
      {
        content: (
          <LeftRightContent
            left="Người yêu cầu:"
            right={<strong>{Request.createdBy.user.displayName}</strong>}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="SĐT Người yêu cầu:"
            right={<strong>{Request.fields.ePhoneNumber}</strong>}
            smColumn={false}
          />
        ),
      },
      {
        content: (
          <LeftRightContent
            left="Cơ quan/Đơn vị:"
            right={<strong>{Request.fields.eDepartment}</strong>}
          />
        ),
      },
      {
        hidden: {
          sm: isEqual(Request.fields.eUnit, Request.fields.eDepartment),
        },
        content: (
          <LeftRightContent
            left="Đơn vị:"
            right={<strong>{Request.fields.eUnit}</strong>}
          />
        ),
      },
    ];
  }, [Request]);


  const fullColData = useMemo(() => {
    const eDeptHeadCommentData = eDeptHeadComment ? JSON.parse(eDeptHeadComment) : [];
    const eITLeadCommentData = eITLeadComment ? JSON.parse(eITLeadComment) : [];
    const eITHeadCommentData = eITHeadComment ? JSON.parse(eITHeadComment) : [];
    const eAssigneeCommentData = eAssigneeComment ? JSON.parse(eAssigneeComment) : [];

    return [
      {
        content: <TableModal data={JSON.parse(Request.fields.eContent)} columns={tableColumns} />,
      },
      {
        content: (
          <Fragment>
            Tệp đính kèm
            <div className="mt-2 d-flex flex-column">
              <FileAttachmentCard
                listFile={
                  Request.fields.eFileContent ? JSON.parse(Request.fields.eFileContent) : []
                }
              />
            </div>
          </Fragment>
        ),
      },
      {
        content: (
          <Fragment>
            Lịch sử phê duyệt
            <ApprovalHistory>
              <ApprovalHistory.Content
                hidden={!eDeptHeadComment}
                data={eDeptHeadCommentData}
                highlight={`Thủ trưởng CQ/ĐV, ${eApprovedBy.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eITLeadComment}
                data={eITLeadCommentData}
                highlight={`Bộ phận hành chính VPCT, ${eApprovedByITLead.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eITHeadComment}
                data={eITHeadCommentData}
                highlight={`Cán bộ VPCT, ${eApprovedByITHead.split("|")[1]}`}
              />

              <ApprovalHistory.Content
                hidden={!eAssigneeComment}
                data={eAssigneeCommentData}
                highlight={`Bộ phận thực hiện cấp vé VPCT, ${eAssignee.split("|")[1]}`}
              />

              <ApprovalHistory.Input
                hidden={approvalStep !== approvalType}
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </ApprovalHistory>
          </Fragment>
        ),
      },
      {
        content: (
          <Fragment>
            Thông tin trao đổi
            <div className="mt-2">
              <CommentSection comments={[]} data={Request} user={user} id={6} className="mb-4" />
            </div>
          </Fragment>
        ),
      },
      {
        hidden: approvalType !== approverType.itlead || approvalStep !== approvalType,
        // hidden: false,
        content: (
          <Fragment>
            Cán bộ duyệt thay thế
            <div className="people_picker-custom-detail">
              <UserSelect
                name="Vui lòng chọn cán bộ VPCT thay thế"
                onTouched={() => 1}
                placeholder="Vui lòng chọn cán bộ VPCT"
                options={eApprovalChangeOptions}
                value={pickedItHead}
                onChange={onApproverChange}
              />
            </div>
          </Fragment>
        ),
      }
    ];
  }, [Request, user, pickedItHead, onApproverChange, approvalType, approvalStep, comment, setComment]);

  return (
    <Fragment>
      <InformationList
        size="sm-col"
        data={smColData}
        renderContent={(item) => item.content}
        getItemHidden={(item) => item.hidden}
      />
      <InformationList size="full-col" data={fullColData} renderContent={(item) => item.content} getItemHidden={(item) => item.hidden}/>
    </Fragment>
  );
};

export default FormContent;
